export const YEAR2_COUNCILS = [
  { number: 1, title: 'The Diagnosis', outputs: ['sim_scan', 'strategic_intelligence_brief', 'session_summary'] },
  { number: 2, title: 'The Insight', outputs: ['leverage_canvas_scan', 'leverage_point_brief', 'session_summary'] },
  { number: 3, title: 'The Startup', outputs: ['startup_brief_scan', 'startup_proposal', 'startup_report', 'startup_youtube_url', 'startup_photos', 'session_summary'] },
  { number: 4, title: 'The Proposal', outputs: ['policy_canvas_scan', 'policy_proposal', 'session_summary'] },
  { number: 5, title: 'The Crucible', outputs: ['crisis_amendment_scan', 'portfolio_completion', 'session_summary'] },
];

// For portfolio seal, one session_summary per council_number 1–5 is required.
// Backend enforces this by counting distinct council_number values for session_summary outputs.
export const YEAR2_SEAL_REQUIRED_OUTPUT_TYPES = [
  'strategic_intelligence_brief','leverage_point_brief','startup_proposal',
  'startup_report','policy_proposal','crisis_amendment_scan',
  'startup_youtube_url',
  'session_summary', // must have 5 rows (council_number 1–5) — checked server-side by count
];